<template>
    <form-wrapper class="form__fields" :isSubmittable="false">
        <div class="auth-register-with-npi-form">
            <text-field
                :label="$t('forms.auth.profile.fields.npi_number.label')"
                :placeholder="$t('forms.auth.profile.fields.npi_number.placeholder')"
                :isRequired="true"
                :hasAutofocus="true"
                :formData="data"
                :error="npiErrorMessage"
                valuePath="npiNumber"
                @change="change($event)"
            ></text-field>

            <common-buttons class="npi-number-not-found-buttons">
                <common-button
                    :label="$t('forms.auth.profile.fields.npi_number.verify')"
                    :isProcessing="isLoading"
                    type="primary"
                    size="small"
                    @click="matchProviderData"
                ></common-button>
            </common-buttons>
            <common-divider></common-divider>
            <p class="register-link">
                {{ $t('pages.auth.signup.dont_have_npi') }}
                <span class="npi-number-not-found" @click="emitEvent({ name: 'go-wtihout-npi' })">
                    {{ $t('pages.auth.signup.start_new_registration') }}
                </span>
            </p>
            <p class="register-link">
                {{ $t('pages.auth.signup.have_account') }}
                <router-link :to="{ name: 'auth.login' }" class="npi-number-not-found">
                    {{ $t('pages.auth.signup.log_in') }}
                </router-link>
            </p>
        </div>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import ProviderDatabaseAPI from 'api/ProviderDatabaseAPI'

    export default {
        mixins: [FormMixin],

        data() {
            return {
                isLoading: false,
                npiErrorMessage: '',
            }
        },

        methods: {
            matchProviderData() {
                if (this.data.npiNumber.length !== 10) {
                    this.npiErrorMessage = this.$t('pages.auth.signup.npi_number_must_be_10_digits')
                    return
                }
                this.isLoading = true
                ProviderDatabaseAPI.get(this.data.npiNumber)
                    .then((res) => {
                        this.$router.push({ name: 'auth.signup.register', query: { npi: this.data.npiNumber } })
                        this.emitEvent({ name: 'provider-data-matched', payload: res })
                    })
                    .catch(() => {
                        this.npiErrorMessage = this.$t('pages.auth.signup.npi_number_not_found')
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';

    .auth-register-with-npi-form {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .npi-number-not-found {
        text-align: center;
        cursor: pointer;
        color: $color--accent-1;
    }
    .register-link {
        margin: 0;
        text-align: center;
    }
    .npi-number-not-found-buttons {
        margin: 20px 0;
    }
</style>
